import { useTranslation } from 'react-i18next';
import { WebEditPageShell } from '../../../components/cv/WebEditPageShell';
import { EditLanguagesForm } from '../../../components/cv/forms/EditLanguagesForm';
import { useSaveLanguages } from '../../../hooks/useProfileApi';
import { mapLanguagesToAPI } from '../../../lib/cv-mapping';

export default function EditLanguagesWebScreen() {
  const { t } = useTranslation('seeker');
  const saveLangs = useSaveLanguages();

  const handleSave = async (languages: string[]) => {
    await saveLangs.mutateAsync(mapLanguagesToAPI(languages));
  };

  return (
    <WebEditPageShell title={t('cv.edit.languages')}>
      <EditLanguagesForm onSave={handleSave} />
    </WebEditPageShell>
  );
}
